module.exports = __webpack_public_path__ + "img/gold_symbol_8.3302da91.png";